import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Manifesto from "./components/Manifesto";
import CategorySection from "./components/CategorySection";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import { CATEGORIAS } from "./data/chales";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F6F5F2] text-[#1C3026]">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        {CATEGORIAS.map((c, i) => (
          <CategorySection
            key={c.id}
            categoria={c}
            index={i}
            anchorId={i === 0 ? "chales" : c.id}
          />
        ))}
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster position="top-center" />
    </div>
  );
}
